import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { TextEditorValue } from '@dreryk/react-text-editor';
import { FieldController } from '@dreryk/react-common';

import { InterviewTextEditor } from '../../form/interview/InterviewTextEditor';
import { StyledPrescriptionVisitDataModalField } from '../PrescriptionVisitDataModal.styled';

type InterviewFieldProps = {
   readonly controller: FieldController<TextEditorValue | null>;
   readonly practitionerId: PractitionerId;
   readonly visitId: number;
};

export const InterviewField = (props: InterviewFieldProps): JSX.Element => {
   return (
      <StyledPrescriptionVisitDataModalField>
         <InterviewTextEditor
            controller={props.controller}
            practitionerId={props.practitionerId}
            visitId={props.visitId}
            labelSuffix={<></>}
         />
      </StyledPrescriptionVisitDataModalField>
   );
};
